// Port of api/fuel/app/classes/insights/worth/history.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function monthStartOffset(monthOffset) {
	var date = new Date()
	date.setUTCDate(1)
	date.setUTCHours(0, 0, 0, 0)
	date.setUTCMonth(date.getUTCMonth() + monthOffset)
	return Math.floor(date.getTime() / 1000)
}

export default Segment.extend({
	name: 'history',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	run: function(type, owner) {
		var history = []
		var since = monthStartOffset(-11)
		var raw = Util.queryFast(
			'SELECT insight_stamp AS month, insight_value AS total, insight_count AS c, insight_count_valued AS cv' +
			' FROM insight_user_collection WHERE insight_date >= ' + since +
			' AND user_id = ' + owner.get_id() +
			' ORDER BY insight_date ASC'
		)

		for (var i = 0; i < raw.length; i++) {
			var countValued = parseInt(raw[i].cv, 10) || 0
			var total = parseFloat(raw[i].total) || 0
			var average = countValued ? (total / countValued) : 0
			history.push({
				month: raw[i].month,
				total: parseInt(Math.round(total * 100) / 100, 10),
				average: parseInt(Math.round(average * 100) / 100, 10)
			})
		}

		return {
			history: history
		}
	}
})
